<template>
  <basic-container>
    <avue-crud
      :option="option"
      :table-loading="loading"
      :data="data"
      ref="crud"
      @on-load="onLoad"
      @refresh-change="onLoad"
    >
      <template slot="menuLeft">
        <el-button type="primary" size="small" icon="el-icon-plus" @click="openAddForm('add')"
          >新 增
        </el-button>
      </template>
      <template slot="menu" slot-scope="scope">
        <el-button
          type="text"
          size="small"
          icon="el-icon-view"
          @click="openPassRuleForm(scope.row, 'view')"
          >查看
        </el-button>
        <el-button type="text" size="small" @click="openPassRuleForm(scope.row, 'edit')">
          <span class="el-icon-edit"></span>编辑
        </el-button>
        <el-button type="text" size="small" @click="removePassRule(scope.row)">
          <span class="el-icon-delete"></span>删除
        </el-button>
      </template>
    </avue-crud>
    <el-form
      v-if="showPassRuleForm"
      :model="parkpassruleFrom"
      :disabled="operateType === 'view'"
      status-icon="true"
      :rules="formRules"
      ref="ruleForm"
      label-suffix=" :"
      label-width="100px"
    >
      <el-row :gutter="30">
        <el-col span="12">
          <el-form-item
            label="规则名称"
            prop="ruleName"
            :rules="[
              { required: true, message: '请输入规则名称', trigger: 'blur' },
              { min: 3, max: 16, message: '长度在 3 到 16 个字符', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model="parkpassruleFrom.ruleName"
              placeholder="请输入规则名称3-16位"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item
            label="规则编号"
            prop="ruleCode"
            :rules="[
              { required: true, message: '请输入规则编号', trigger: 'blur' },
              { min: 3, max: 16, message: '长度在 3 到 16 个字符', trigger: 'blur' },
            ]"
          >
            <el-input
              v-model="parkpassruleFrom.ruleCode"
              :disabled="operateType === 'edit'"
              placeholder="请输入规则编号3-16位"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="30">
        <el-col span="12">
          <el-form-item
            label="出入类型"
            prop="passageType"
            :rules="[{ required: true, message: '请选择出入类型', trigger: 'blur' }]"
          >
            <el-select
              v-model="parkpassruleFrom.passageType"
              :disabled="operateType === 'edit'"
              @change="$forceUpdate()"
              placeholder="请选择出入类型"
              style="width: 100%"
            >
              <el-option
                v-for="item in options"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col span="12">
          <el-form-item
            label="描述"
            prop="remark"
            :rules="[{ min: 3, max: 12, message: '长度在 3 到 12 个字符', trigger: 'blur' }]"
          >
            <el-input v-model="parkpassruleFrom.remark" placeholder="请输入规则描述"></el-input>
          </el-form-item>
        </el-col>
      </el-row>
      <el-tabs v-model="activeName" @tab-click="handleClick">
        <el-tab-pane name="in">
          <span slot="label">临时车</span>
          <div v-if="parkpassruleFrom.passageType == 1">
            <el-row>
              <el-form-item label="内部车自动入场" label-width="175px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="tempCarRule.settingRules.normalPass.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options5"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input v-model="tempCarRule.settingRules.normalPass.remark"></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="外部车自动入场" label-width="175px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="tempCarRule.settingRules.useHouseholdTempcar.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options7"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input
                    v-model="tempCarRule.settingRules.useHouseholdTempcar.remark"
                  ></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="车位已满允许自动入场" label-width="175px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="tempCarRule.settingRules.parkSpaceFull.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input v-model="tempCarRule.settingRules.parkSpaceFull.remark"></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="车辆重复允许自动入场" label-width="175px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="tempCarRule.settingRules.vehicleDuplicated.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input v-model="tempCarRule.settingRules.vehicleDuplicated.remark"></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="军警车自动入场" label-width="175px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="tempCarRule.settingRules.policeCarAutoPass.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input v-model="tempCarRule.settingRules.policeCarAutoPass.remark"></el-input>
                </el-col>
              </el-form-item>
            </el-row>
          </div>
          <div v-show="parkpassruleFrom.passageType == 2">
            <div>
              <el-row>
                <el-form-item label="正常出场" label-width="205px" prop="name">
                  <el-col span="5">
                    <el-select
                      v-model="tempCarRuleOut.settingRules.normalPass.statusType"
                      style="width: 100px"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in options3"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col class="line" span="14">
                    <el-input v-model="tempCarRuleOut.settingRules.normalPass.remark"></el-input>
                  </el-col>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="无入场记录允许自动出场" label-width="205px" prop="name">
                  <el-col span="5">
                    <el-select
                      v-model="tempCarRuleOut.settingRules.withoutInRecord.statusType"
                      style="width: 100px"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in options8"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col class="line" span="14">
                    <el-input
                      v-model="tempCarRuleOut.settingRules.withoutInRecord.remark"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </el-row>
              <!-- <el-row>
                      <el-form-item label="按最近入场记录匹配" label-width="205px" prop="name">
                        <el-col span="5">
                          <el-select
                            v-model="tempCarRuleOut.settingRules.matchByLastIn.statusType"
                            style="width: 100px"
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="item in options2"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-col>
                        <el-col class="line" span="14">
                          <el-input v-model="tempCarRuleOut.settingRules.matchByLastIn.remark"></el-input>
                        </el-col>
                      </el-form-item>
                    </el-row> -->
              <el-row>
                <el-form-item label="军管车自动出场" label-width="205px" prop="name">
                  <el-col span="5">
                    <el-select
                      v-model="tempCarRuleOut.settingRules.policeCarAutoPass.statusType"
                      style="width: 100px"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in options3"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col class="line" span="14">
                    <el-input
                      v-model="tempCarRuleOut.settingRules.policeCarAutoPass.remark"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </el-row>
              <el-row>
                <el-form-item label="收费0元自动开闸" label-width="205px" prop="name">
                  <el-col span="5">
                    <el-select
                      v-model="tempCarRuleOut.settingRules.autoOpenWithoutPay.statusType"
                      style="width: 100px"
                      placeholder="请选择"
                    >
                      <el-option
                        v-for="item in options3"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                      >
                      </el-option>
                    </el-select>
                  </el-col>
                  <el-col class="line" span="14">
                    <el-input
                      v-model="tempCarRuleOut.settingRules.autoOpenWithoutPay.remark"
                    ></el-input>
                  </el-col>
                </el-form-item>
              </el-row>
              <!-- <el-row>
                      <el-form-item label="无法识别车辆按最低标准收费" label-width="205px" prop="name">
                        <el-col span="5">
                          <el-select
                            v-model="tempCarRuleOut.settingRules.lowerBarWhenUnrecognized.statusType"
                            style="width: 100px"
                            placeholder="请选择"
                          >
                            <el-option
                              v-for="item in options2"
                              :key="item.value"
                              :label="item.label"
                              :value="item.value"
                            >
                            </el-option>
                          </el-select>
                        </el-col>
                        <el-col class="line" span="14">
                          <el-input
                            v-model="tempCarRuleOut.settingRules.lowerBarWhenUnrecognized.remark"
                          ></el-input>
                        </el-col>
                      </el-form-item>
                    </el-row> -->
            </div>
          </div>
          <!-- <el-row style="text-align: center"  v-show="operateType !== 'view'">
                  <el-form-item style="text-align: center">
                    <el-button type="primary" @click="onSubmit" size="small" icon="el-icon-check" :loading = 'submitting'>提 交</el-button>
                  </el-form-item>
                </el-row> -->
        </el-tab-pane>
        <el-tab-pane name="out">
          <span slot="label">月卡车</span>
          <!-- 临时车 -->
          <div v-if="parkpassruleFrom.passageType == 1">
            <el-row>
              <el-form-item label="正常入场" label-width="175px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="monthCarRule.settingRules.normalPass.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input v-model="monthCarRule.settingRules.normalPass.remark"></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="车位已满允许自动入场" label-width="175px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="monthCarRule.settingRules.parkSpaceFull.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input v-model="monthCarRule.settingRules.parkSpaceFull.remark"></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="车辆重复允许自动入场" label-width="175px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="monthCarRule.settingRules.vehicleDuplicated.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input v-model="monthCarRule.settingRules.vehicleDuplicated.remark"></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="车位被占用允许自动入场" label-width="175px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="monthCarRule.settingRules.parkSpaceUsed.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input v-model="monthCarRule.settingRules.parkSpaceUsed.remark"></el-input>
                </el-col>
              </el-form-item>
            </el-row>

            <div style="font-weight: bold; margin-bottom: 20px">月卡车入场续约提示</div>

            <el-row style="border-bottom: 2px solid #eee; margin-bottom: 20px" :gutter="24">
              <el-col span="4">
                <el-form-item label="剩余" prop="carPermissions1">
                  <el-input v-model="carExpiredRules[0].dayCount" type="number"> </el-input>
                </el-form-item>
              </el-col>
              <el-col span="20">
                <div style="height: 30px; width: 50%">
                  <el-form-item
                    prop="name"
                    label="天，提示用户"
                    label-width="110px"
                    style="margin-bottom: 0"
                  >
                    <el-input
                      style="width: 100%"
                      v-model="carExpiredRules[0].remark"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <div style="font-weight: bold; margin-bottom: 20px">车位组车辆入场续约提示</div>
            <el-row style="border-bottom: 2px solid #eee; margin-bottom: 10px" :gutter="24">
              <el-col span="4">
                <el-form-item label="剩余" prop="name">
                  <el-input v-model="spaceExpiredRules[0].dayCount"></el-input>
                </el-form-item>
              </el-col>
              <el-col span="20">
                <div style="height: 30px; width: 50%">
                  <el-form-item
                    prop="name"
                    label="天，提示用户"
                    label-width="110px"
                    style="margin-bottom: 0"
                  >
                    <el-input
                      style="width: 100%"
                      v-model="spaceExpiredRules[0].remark"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </div>

          <!-- 月卡车 -->
          <div v-show="parkpassruleFrom.passageType == 2">
            <el-row>
              <el-form-item label="正常出场" label-width="190px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="monthCarRuleOut.settingRules.normalPass.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options3"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input v-model="monthCarRuleOut.settingRules.normalPass.remark"></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="无入场记录自动出场" label-width="190px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="monthCarRuleOut.settingRules.withoutInRecord.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options8"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input
                    v-model="monthCarRuleOut.settingRules.withoutInRecord.remark"
                  ></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <!--            <el-row>-->
            <!--              <el-form-item label="车位被占需缴费" label-width="190px" prop="name">-->
            <!--                <el-col span="5">-->
            <!--                  <el-select-->
            <!--                    v-model="monthCarRuleOut.settingRules.parkSpaceUsedPay.statusType"-->
            <!--                    style="width: 100px"-->
            <!--                    placeholder="请选择"-->
            <!--                  >-->
            <!--                    <el-option-->
            <!--                      v-for="item in options2"-->
            <!--                      :key="item.value"-->
            <!--                      :label="item.label"-->
            <!--                      :value="item.value"-->
            <!--                    >-->
            <!--                    </el-option>-->
            <!--                  </el-select>-->
            <!--                </el-col>-->
            <!--                <el-col class="line" span="14">-->
            <!--                  <el-input-->
            <!--                    v-model="monthCarRuleOut.settingRules.parkSpaceUsedPay.remark"-->
            <!--                  ></el-input>-->
            <!--                </el-col>-->
            <!--              </el-form-item>-->
            <!--            </el-row>-->
            <el-row>
              <el-form-item label="车位过期允许按临时车缴费" label-width="190px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="monthCarRuleOut.settingRules.parkSpaceExpiredToTemp.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input
                    v-model="monthCarRuleOut.settingRules.parkSpaceExpiredToTemp.remark"
                  ></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="过期月卡车按临时车缴费" label-width="190px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="monthCarRuleOut.settingRules.vehicleExpiredToTemp.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                  >
                    <el-option
                      v-for="item in options2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input
                    v-model="monthCarRuleOut.settingRules.vehicleExpiredToTemp.remark"
                  ></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <el-row>
              <el-form-item label="月卡车出场补缴临停费" label-width="190px" prop="name">
                <el-col span="5">
                  <el-select
                    v-model="monthCarRuleOut.settingRules.noStartMonthCarToTemp.statusType"
                    style="width: 100px"
                    placeholder="请选择"
                    @change="$forceUpdate()"
                  >
                    <el-option
                      v-for="item in options2"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-col>
                <el-col class="line" span="14">
                  <el-input
                    v-model="monthCarRuleOut.settingRules.noStartMonthCarToTemp.remark"
                  ></el-input>
                </el-col>
              </el-form-item>
            </el-row>
            <!-- <el-row>
                    <el-form-item label="按最近入场纪录匹配" label-width="190px" prop="name">
                      <el-col span="5">
                        <el-select
                          v-model="monthCarRuleOut.settingRules.matchByLastIn.statusType"
                          style="width: 100px"
                          placeholder="请选择"
                        >
                          <el-option
                            v-for="item in options3"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                          >
                          </el-option>
                        </el-select>
                      </el-col>
                      <el-col class="line" span="14">
                        <el-input v-model="monthCarRuleOut.settingRules.matchByLastIn.remark"></el-input>
                      </el-col>
                    </el-form-item>
                  </el-row> -->
            <div style="font-weight: bold; margin-bottom: 20px">月卡车出场续约提示</div>

            <el-row style="border-bottom: 2px solid #eee; margin-bottom: 10px" :gutter="24">
              <el-col span="4">
                <el-form-item label="剩余" prop="carPermissions1">
                  <el-input v-model="carExpiredRulesOut[0].dayCount" type="number"> </el-input>
                </el-form-item>
              </el-col>
              <el-col span="20">
                <div style="height: 30px; width: 50%">
                  <el-form-item
                    prop="name"
                    label="天，提示用户"
                    label-width="110px"
                    style="margin-bottom: 0"
                  >
                    <el-input
                      style="width: 100%"
                      v-model="carExpiredRulesOut[0].remark"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>

            <div style="font-weight: bold; margin-bottom: 20px">车位组车辆出场续约提示</div>
            <el-row style="border-bottom: 2px solid #eee; margin-bottom: 10px" :gutter="24">
              <el-col span="4">
                <el-form-item label="剩余" prop="name">
                  <el-input v-model="spaceExpiredRulesOut[0].dayCount"></el-input>
                </el-form-item>
              </el-col>
              <el-col span="20">
                <div style="height: 30px; width: 50%">
                  <el-form-item
                    prop="name"
                    label="天，提示用户"
                    label-width="110px"
                    style="margin-bottom: 0"
                  >
                    <el-input
                      style="width: 100%"
                      v-model="carExpiredRulesOut[0].remark"
                      :disabled="true"
                    ></el-input>
                  </el-form-item>
                </div>
              </el-col>
            </el-row>
          </div>
          <!-- <el-row style="text-align: center" v-show="operateType !== 'view'">
                  <el-form-item style="text-align: center">
                    <el-button type="primary" @click="onSubmit" size="small" icon="el-icon-check" :loading = 'submitting'>提 交</el-button>
                  </el-form-item>
                </el-row> -->
        </el-tab-pane>
      </el-tabs>
    </el-form>
  </basic-container>
</template>

<script>
import {
  getPassRuleList,
  addPassRule,
  updatePassRule,
  getPassRuleDetail,
  removePassRule,
} from '@/views/v4ward/carv2/merge/api/park-merge';
import { syncData } from '@/api/v4ward/carv2/carparkspace';
export default {
  props: {
    saveBtnShow: false,
    parkSpace: {},
  },
  data() {
    return {
      next: false,
      loading: false,
      form: {},
      syncButtonLoading: false,
      showPassRuleForm: false,
      submitting: false,
      operateType: '',
      parkpassruleFrom: {},
      activeName: 'in',
      tempCarRule: {
        //临时车规则 入场
        setmealType: 1,
        settingRules: {
          normalPass: {
            remark: '',
            statusType: 1,
          },
          parkSpaceFull: {
            remark: '车位已满，禁止通行',
            statusType: 4,
          },
          policeCarAutoPass: {
            remark: '',
            statusType: 1,
          },
          vehicleDuplicated: {
            remark: '',
            statusType: 1,
          },
          useHouseholdTempcar: {
            remark: '',
            statusType: 4,
          },
        },
      },
      monthCarRule: {
        //月卡车规则 入场
        setmealType: 1,
        settingRules: {
          normalPass: {
            remark: '',
            statusType: 1,
          },
          parkSpaceFull: {
            remark: '',
            statusType: 1,
          },
          parkSpaceUsed: {
            remark: '',
            statusType: 1,
          },
          vehicleDuplicated: {
            remark: '',
            statusType: 1,
          },
        },
      },
      carExpiredRules: [
        {
          //车辆规则 入场
          remark: '月卡车,剩余TT天,请尽快延期',
          dayCount: 20,
          statusType: 1,
        },
        // {
        //   remark: '月卡车,已过期，请尽快延期',
        //   dayCount: 0,
        //   statusType: 1,
        // },
        // {
        //   remark: '月卡车,已过期，禁止通行',
        //   dayCount: -1,
        //   statusType: 4,
        // },
      ],
      spaceExpiredRules: [
        {
          //车位规则 入场
          remark: '固定车,剩余TT天,请尽快延期',
          dayCount: 20,
          statusType: 1,
        },
        // {
        //   remark: '',
        //   dayCount: 0,
        //   statusType: 1,
        // },
        // {
        //   remark: '',
        //   dayCount: -1,
        //   statusType: 4,
        // },
      ],
      // 出场
      tempCarRuleOut: {
        //临时车规则 出场
        setmealType: 4,
        settingRules: {
          normalPass: {
            remark: '',
            statusType: 1,
          },
          matchByLastIn: {
            remark: '',
            statusType: 4,
          },
          withoutInRecord: {
            remark: '',
            statusType: 1,
          },
          policeCarAutoPass: {
            remark: '',
            statusType: 1,
          },
          autoOpenWithoutPay: {
            remark: '',
            statusType: 1,
          },
          lowerBarWhenUnrecognized: {
            remark: '',
            statusType: 4,
          },
        },
      },
      monthCarRuleOut: {
        //月卡车规则 出场
        setmealType: 4,
        settingRules: {
          normalPass: {
            remark: '',
            statusType: 1,
          },
          matchByLastIn: {
            remark: '',
            statusType: 1,
          },
          withoutInRecord: {
            remark: '',
            statusType: 1,
          },
          parkSpaceUsedPay: {
            remark: '',
            statusType: 5,
          },
          vehicleExpiredToTemp: {
            remark: '',
            statusType: 5,
          },
          noStartMonthCarToTemp: {
            remark: '',
            statusType: 4,
          },
          parkSpaceExpiredToTemp: {
            remark: '',
            statusType: 5,
          },
        },
      },
      spaceExpiredRulesOut: [
        {
          //车位规则 出场
          remark: '固定车,剩余TT天,请尽快延期',
          dayCount: 20,
          statusType: 1,
        },
        // {
        //   remark: '',
        //   dayCount: 0,
        //   statusType: 1,
        // },
        // {
        //   remark: '',
        //   dayCount: -1,
        //   statusType: 4,
        // },
      ],
      carExpiredRulesOut: [
        {
          //车辆规则 出场
          remark: '月卡车,剩余TT天,请尽快延期',
          dayCount: 20,
          statusType: 1,
        },
        // {
        //   remark: '月卡车,已过期,请尽快延期',
        //   dayCount: 0,
        //   statusType: 1,
        // },
        // {
        //   remark: '月卡车,已过期,通行',
        //   dayCount: -1,
        //   statusType: 4,
        // },
      ],
      options: [
        { label: '出口规则', value: 2 },
        { label: '入口规则', value: 1 },
      ],
      options3: [
        { label: '允许', value: 1 },
        { label: '确认', value: 2 },
        { label: '禁止', value: 4 },
      ],
      options4: [
        { label: '允许', value: 1 },
        { label: '确认', value: 2 },
        { label: '警告', value: 3 },
        { label: '禁止', value: 4 },
      ],
      options5: [
        { label: '允许', value: 1 },
        { label: '确认', value: 2 },
        { label: '禁止', value: 4 },
      ],
      options6: [
        { label: '禁止', value: 4 },
        { label: '允许', value: 5 },
      ],
      options2: [
        { label: '禁止', value: 4 },
        { label: '启用', value: 5 },
      ],
      options7: [
        { label: '禁止', value: 4 },
        { label: '确认', value: 2 },
        { label: '允许', value: 5 },
      ],
      options8: [
        { label: '允许', value: 1 },
        { label: '确认', value: 2 },
        { label: '禁止', value: 4 },
        { label: '匹配上次', value: 6 },
      ],
      formRules: {
        parkingLotId: [{ required: true, message: '请输入活动名称', trigger: 'blur' }],
      },
      option: {
        calcHeight: 350,
        tip: false,
        border: true,
        index: false,
        selection: false,
        columnBtn: false,
        viewBtn: false,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        menuType: 'text',
        refreshBtn: false,
        align: 'center',
        menuWidth: 200,
        submitBtn: false,
        column: [
          {
            label: '规则名称',
            prop: 'ruleName',
            maxlength: 32,
            rules: [
              {
                required: true,
                message: '请输入规则名称',
                trigger: 'change',
              },
            ],
          },
          {
            label: '规则编号',
            prop: 'ruleCode',
            maxlength: 16,
            rules: [
              {
                required: true,
                message: '请输入规则编号',
                trigger: 'change',
              },
            ],
          },
          {
            label: '出入类型',
            prop: 'passageType',
            type: 'select',
            dicData: [
              { label: '入口规则', value: 1 },
              { label: '出口规则', value: 2 },
            ],
            props: {
              label: 'label',
              value: 'value',
            },
            rules: [
              {
                required: true,
                message: '请选择出入类型',
                trigger: 'change',
              },
            ],
          },
          {
            label: '规则数据(json)',
            prop: 'ruleData',
            hide: true,
            type: 'textarea',
            minRows: 2,
            overHidden: true,
            display: false,
            rules: [
              {
                required: true,
                message: '请输入规则数据:json数据',
                trigger: 'change',
              },
            ],
          },
          {
            label: '备注信息',
            prop: 'remark',
            type: 'textarea',
            minRows: 2,
            maxlength: 128,
            overHidden: true,
          },
        ],
      },
    };
  },
  created() {
    setTimeout(() => {
      document.querySelector('#pane-passRule > div > div > div').style =
        'padding-top:0px !important';
      document.querySelector(
        '#pane-passRule > div > div > div > div.avue-crud > div.avue-crud__pagination'
      ).style = 'padding-top:0px !important';
      //document.querySelector("#pane-passRule > div > div > div > div.avue-crud > div.avue-crud__menu").style = 'min-height:10px !important';
    });
  },
  mounted() {},
  methods: {
    formSubmit(next) {
      if (next) {
        this.next = next;
        if (this.data.length) {
          this.$emit('getQuestionResult', this.next);
        } else {
          this.$message({
            message: '请至少添加一条数据，再执行该操作。',
            type: 'warning',
          });
        }
      } else {
        this.next = false;
        this.onSubmit();
      }
    },
    toEdit(row) {
      this.form = row;
    },
    onLoad() {
      this.loading = true;
      getPassRuleList({ parkingLotId: this.parkSpace.id }).then((data) => {
        this.data = data.data.records;
        this.loading = false;
      });
    },
    emptyChange() {
      if (this.operateType === 'add') {
        this.cleanForm();
      } else {
        this.$message.warning('编辑时清空无效！');
      }
    },
    //新增
    openAddForm(operateType) {
      this.operateType = operateType;
      this.showPassRuleForm = !this.showPassRuleForm;
      this.$emit('update:saveBtnShow', this.showPassRuleForm);
      this.parkpassruleFrom = {};
    },
    //查看，修改
    openPassRuleForm(data, operateType) {
      this.operateType = operateType;
      getPassRuleDetail({
        parkingLotId: this.parkSpace.id,
        passageType: data.passageType,
        id: data.id,
      })
        .then((res) => {
          this.parkpassruleFrom = res.data;
          setTimeout(() => {
            this.showPassRuleForm = !this.showPassRuleForm;
            if (this.operateType == 'view') {
              this.$emit('update:saveBtnShow', false);
            } else {
              this.$emit('update:saveBtnShow', this.showPassRuleForm);
            }
            if (!this.showPassRuleForm) {
              return;
            }
            this.showData(this.parkpassruleFrom);
          }, 0);
        })
        .catch((res) => {});
    },
    //删除
    removePassRule(row) {
      this.$confirm('确定删除该通行规则?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        removePassRule({ id: row.id, parkingLotId: this.parkSpace.id })
          .then(() => {
            this.onLoad();
          })
          .catch(() => {
            this.onLoad();
          });
      });
    },
    showData(data) {
      if (data.length !== 0) {
        let rules = JSON.parse(data.ruleData);
        if (data.passageType === 1) {
          this.tempCarRule = rules.tempCarRule;
          this.monthCarRule = rules.monthCarRule;
          this.carExpiredRules = rules.monthCarRule.carExpiredRules;
          this.spaceExpiredRules = rules.monthCarRule.spaceExpiredRules;
        } else if (data.passageType == 2) {
          this.tempCarRuleOut = rules.tempCarRule;
          this.monthCarRuleOut = rules.monthCarRule;
          this.carExpiredRulesOut = rules.monthCarRule.carExpiredRules;
          this.spaceExpiredRulesOut = rules.monthCarRule.spaceExpiredRules;
          if (!this.monthCarRuleOut.settingRules.noStartMonthCarToTemp) {
            this.monthCarRuleOut.settingRules.noStartMonthCarToTemp = { remark: '', statusType: 4 };
          }
        }
      }
    },
    onSubmit(type) {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          // 验证车辆过期允许入场权限 月卡车入场
          for (let i = 0; i < this.carExpiredRules.length; i++) {
            let reg = /^\+?[1-9][0-9]*$/;
            let reg2 = /^((-\d+)|(0+))$/;
            if (this.carExpiredRules[i].dayCount === '') {
              this.$message.error('请输入车辆过期允许入场，权限' + (i + 1));
              return;
            }
            if (
              !(
                reg.test(this.carExpiredRules[i].dayCount) ||
                reg2.test(this.carExpiredRules[i].dayCount)
              )
            ) {
              this.$message.error(
                '格式错误！请输入车辆过期允许入场,权限' + (i + 1) + '天数为数字！'
              );
              return;
            }
            reg.lastIndex = 0;
            reg2.lastIndex = 0;
          }
          // // 验证车位过期允许入场权限 月卡车入场
          for (let i = 0; i < this.spaceExpiredRules.length; i++) {
            let reg = /^\+?[1-9][0-9]*$/;
            let reg2 = /^((-\d+)|(0+))$/;
            if (this.spaceExpiredRules[i].dayCount === '') {
              this.$message.error('请输入车位过期允许入场，权限' + (i + 1));
              return;
            }
            if (
              !(
                reg.test(this.spaceExpiredRules[i].dayCount) ||
                reg2.test(this.spaceExpiredRules[i].dayCount)
              )
            ) {
              this.$message.error(
                '格式错误！请输入车位过期允许入场,权限' + (i + 1) + '天数为数字！'
              );
              return;
            }
            reg.lastIndex = 0;
            reg2.lastIndex = 0;
          }
          // 验证车辆过期允许出场权限 月卡车出场
          for (let i = 0; i < this.carExpiredRulesOut.length; i++) {
            let reg = /^\+?[1-9][0-9]*$/;
            let reg2 = /^((-\d+)|(0+))$/;
            if (this.carExpiredRulesOut[i].dayCount === '') {
              this.$message.error('请输入车辆过期允许出场，权限' + (i + 1));
              return;
            }
            if (
              !(
                reg.test(this.carExpiredRulesOut[i].dayCount) ||
                reg2.test(this.carExpiredRulesOut[i].dayCount)
              )
            ) {
              this.$message.error(
                '格式错误！请输入车辆过期允许出场,权限' + (i + 1) + '天数为数字！'
              );
              return;
            }
            reg.lastIndex = 0;
            reg2.lastIndex = 0;
          }
          // 验证车位过期允许出场权限 月卡车出场
          for (let i = 0; i < this.spaceExpiredRulesOut.length; i++) {
            let reg = /^\+?[1-9][0-9]*$/;
            let reg2 = /^((-\d+)|(0+))$/;
            if (this.spaceExpiredRulesOut[i].dayCount === '') {
              this.$message.error('请输入车位过期允许出场，权限' + (i + 1));
              return;
            }
            if (
              !(
                reg.test(this.spaceExpiredRulesOut[i].dayCount) ||
                reg2.test(this.spaceExpiredRulesOut[i].dayCount)
              )
            ) {
              this.$message.error(
                '格式错误！请输入车位过期允许出场,权限' + (i + 1) + '天数为数字！'
              );
              return;
            }
            reg.lastIndex = 0;
            reg2.lastIndex = 0;
          }
          this.inRuleForm();
          if (this.vdui.isEmpty(this.parkpassruleFrom.id)) {
            this.rowSave();
          } else {
            this.rowUpdate();
          }
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    },
    rowSave() {
      this.submitting = true;
      this.parkpassruleFrom.parkingLotId = this.parkSpace.id;
      addPassRule(this.parkpassruleFrom).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.parkpassruleFrom = {};
          this.parkpassruleFrom.passageType = 1;
          this.submitting = false;
          this.showPassRuleForm = false;
          this.$emit('update:saveBtnShow', this.showPassRuleForm);
        },
        (error) => {
          window.console.log(error);
          this.submitting = false;
        }
      );
    },
    rowUpdate(row, index, done, loading) {
      this.submitting = true;
      updatePassRule(this.parkpassruleFrom).then(
        () => {
          this.onLoad();
          this.$message.success('操作成功!');
          this.submitting = false;
          this.showPassRuleForm = false;
          this.$emit('update:saveBtnShow', this.showPassRuleForm);
        },
        (error) => {
          window.console.log(error);
          this.submitting = false;
        }
      );
    },
    inRuleForm() {
      let obj = {};
      if (this.parkpassruleFrom.passageType === 1) {
        obj.tempCarRule = this.tempCarRule;
        obj.monthCarRule = this.monthCarRule;
        obj.monthCarRule.carExpiredRules = this.carExpiredRules;
        obj.monthCarRule.spaceExpiredRules = this.spaceExpiredRules;
      } else if (this.parkpassruleFrom.passageType === 2) {
        obj.tempCarRule = this.tempCarRuleOut;
        obj.monthCarRule = this.monthCarRuleOut;
        obj.monthCarRule.carExpiredRules = this.carExpiredRulesOut;
        obj.monthCarRule.spaceExpiredRules = this.spaceExpiredRulesOut;
      }
      this.parkpassruleFrom.ruleData = JSON.stringify(obj);
    },
    syncParkInfo(type) {
      this.syncButtonLoading = true;
      const syncParam = {
        dataRange: 2,
        dataType: type,
        parkId: this.parkSpace.id,
      };
      syncData(syncParam).then(
        () => {
          this.$message.success('操作成功！');
          this.syncButtonLoading = false;
        },
        (error) => {
          window.console.log(error);
          this.syncButtonLoading = false;
        }
      );
    },
    cleanForm() {
      for (let key in this.form) {
        this.form[key] = '';
      }
    },
  },
};
</script>
<style scoped></style>
